"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationTransferPage = void 0;
var ConfigurationTransferPage_1 = require("./components/ConfigurationTransferPage");
Object.defineProperty(exports, "ConfigurationTransferPage", { enumerable: true, get: function () { return ConfigurationTransferPage_1.ConfigurationTransferPage; } });
